import { http } from "@/utils/axios";

/**
 * @msg: 获取综合测验列表数据
 */
export function getComprehensiveTestList(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getGeneralTestList'),
        method: 'post',
        params: http.params(data),
        data
    })
}

/**
 * @msg: 获取综合测验列表人数统计数据
 */
export function getComprehensiveTestPeopleList(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getGeneralTestStatistics'),
        method: 'post',
        params: http.params(data),
        data
    })
}



/**
 * @msg: 获取我的课程列表
 */
// export function getMyOpenCourse(params) {
//     return http({
//         url: http.baseUrl('courseTeacherManage/getMyOpenCourse'),
//         method: 'get',
//         params
//     })
// }